import { GenericTextInput } from './Fields/GenericTextInput'

export function ApplicationCustomerDetails({ onBack }) {
  return (
    <div className="flex flex-col gap-6 min-h-[480px] justify-between">
      <div className="flex flex-col gap-10 popUp">
        {/*   <GenericTextInput
          name="customerDetails.ssn"
          label="SSN / Organization Number"
          placeholder="DC 12345"
          type="text"
        /> */}
        <div className="grid grid-cols-2 gap-6">
          <GenericTextInput name="customerDetails.firstName" label="First Name" placeholder="John" type="text" />
          <GenericTextInput name="customerDetails.lastName" label="Last Name" placeholder="Doe" type="text" />
          <GenericTextInput name="customerDetails.address" label="Address" placeholder="312 Main St" type="text" />
          <GenericTextInput name="customerDetails.zipCode" label="Zip Code" placeholder="100001" type="text" />
          <GenericTextInput name="customerDetails.city" label="City" placeholder="New York" type="text" />
          <GenericTextInput name="customerDetails.phoneNumber" label="Phone" placeholder="923 00 875" type="text" />
          {/*   <GenericTextInput name="customerDetails.email" label="Email" placeholder="john.doe@example.com" type="text" /> */}
        </div>
      </div>
      <div className="flex w-full justify-between">
        <button
          type="button"
          onClick={() => onBack()}
          className="bg-background px-10 text-primary border-2 border-primary rounded-md hover:rounded-xl transition-all ease-in-out shadow-md p-4 flex items-center justify-center gap-4"
        >
          Back
        </button>
        <button
          type="submit"
          className="bg-primary px-10 border-2 text-background border-primary rounded-md hover:rounded-xl transition-all ease-in-out shadow-md p-4 flex items-center justify-center gap-4"
        >
          Submit Application
        </button>
      </div>
    </div>
  )
}
